<template>
  <div class="safety">
    <!--1440*664  8.3  9.6  352.8  215.8 -->
    <div class="HCS_container column">
      <div class="HCS_item item-1" @click="clickChart('1')"
           style="transform: translate(-529.2px, -323.7px) scale(0.25)">
        <manpower :project_id="project_id"></manpower>
      </div>
      <div class="HCS_item item-2" @click="clickChart('2')"
           style="transform:translate(-529.2px, -99.6px)  scale(0.25)">
        <projectcount :project_id="project_id"></projectcount>
      </div>
      <div class="HCS_item item-3" @click="clickChart('3')"
           style="transform:translate(-529.2px, 124.5px)  scale(0.25)">
        <entrystatics :project_id="project_id"></entrystatics>
      </div>
      <div class="HCS_item HCS_item_active item-4" @click="clickChart('4')"
           style="transform:translate(5px, -220px) scale(0.5)">
        <spot style="position: absolute"></spot>
      </div>
      <div class="HCS_item item-5" @click="clickChart('5')"
           style="transform:translate(-166.8px, 124.5px)  scale(0.25)">
        <entry1count :project_id="project_id" :current_gate="cur_gate1" :gate_list="gate_list"></entry1count>
      </div>
      <div class="HCS_item item-6" @click="clickChart('6')"
           style="transform:translate(195.6px, 124.5px)  scale(0.25)">
        <entry2count :project_id="project_id" :current_gate="cur_gate2" :gate_list="gate_list"></entry2count>
      </div>
      <div class="HCS_item item-7" @click="clickChart('7')"
           style="transform:translate(558px, -323.7px)  scale(0.25)">
        <dailystatics :project_id="project_id"></dailystatics>
      </div>
      <div class="HCS_item item-8" @click="clickChart('8')"
           style="transform:translate(558px, -99.6px)  scale(0.25)">
        <weeklystatics :project_id="project_id"></weeklystatics>
      </div>
      <div class="HCS_item item-9" @click="clickChart('9')"
           style="transform:translate(558px, 124.5px)  scale(0.25)">
        <contractor :project_id="project_id"></contractor>
      </div>
    </div>
  </div>
</template>

<script>
import manpower from '@/components/HCS/manpower'
import projectcount from '@/components/HCS/projectcount'
import entrystatics from '@/components/HCS/entrystatics'
import entry1count from '@/components/HCS/entry1count'
import entry2count from '@/components/HCS/entry2count'
import dailystatics from '@/components/HCS/dailystatics'
import weeklystatics from '@/components/HCS/weeklystatics'
import contractor from '@/components/HCS/contractor'
import spot from '@/components/spot/spot'
import axios from 'axios'

export default {
  name: "HCS",
  props: ['my_project_id'],

  data() {
    return {
      tbmCount: [],
      tbmEmpty: true,
      nowTime: '',
      startDate: '2020-01-01',
      startTimes: '',
      container: '',
      items: [],
      cur_gate1: {},
      cur_gate2: {},
      gate_list: [],
      project_id: this.my_project_id,
      if_active: [
        {active: false},
        {active: false},
        {active: false},
        {active: true},
        {active: false},
        {active: false},
        {active: false}
      ],
      active_index: 3,
    }
  },
  methods: {
    clickChart(clickIndex) {
      let activeItem = document.querySelector('.HCS_container .HCS_item_active')
      let activeIndex = activeItem.dataset.order
      let clickItem = this.items[clickIndex - 1]
      if (activeIndex === clickIndex) {
        return
      }
      activeItem.classList.remove('HCS_item_active')
      clickItem.classList.add('HCS_item_active')
      this._setStyle(clickItem, activeItem)

    },
    _setStyle(el1, el2) {
      let transform1 = el1.style.transform
      let transform2 = el2.style.transform
      el1.style.transform = transform2
      el2.style.transform = transform1
    },
    handle_proj() {
      if (this.project_id === '2419') {
        this.project_id = '86'
      } else if (this.project_id === '1261') {
        this.project_id = '30'
      } else if (this.project_id === '2096') {
        this.project_id = '16'
      }
    }
  },
  components: {
    manpower,
    projectcount,
    entrystatics,
    entry1count,
    entry2count,
    dailystatics,
    weeklystatics,
    contractor,
    spot
  },
  created() {
    this.handle_proj()
  },
  mounted() {
    this.items = document.querySelectorAll(('.HCS_container .HCS_item'))
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].dataset.order = i + 1;
    }
    let postData = {
      org_id: window.localStorage.getItem('cons_id'),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token'),
      bes_company_id: window.localStorage.getItem('bes_company_id'),
    }
    axios.post(this.$store.getters.getHCSServer + "GateList", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      if (errNo == "0") {
        this.gate_list = resp.data.result;
        this.cur_gate1 = this.gate_list[0]
        this.cur_gate2 = this.gate_list[1]
      } else {
        console.log('err...', errStr)
      }
    }).catch(error => {
      alert(error)
    })
  }
}
</script>

<style lang="stylus" scoped>

.HCS_item {
  position absolute
  padding 0
  width 98%
  height 130%
  transform scale(0.25)
  text-align center
  transition: all 0.8s
  background rgb(30, 35, 48)
  background-color #31334a
}

.safety
  width 100%
  height 100%

.HCS_container.column
  position: relative;
  width: 100%
  height: 100%
  margin: 0 auto;
  font-size 1em
  box-sizing: content-box;

.HCS_item_active
  height 132.5%
  width 99.3%
</style>



// WEBPACK FOOTER //
// src/components/hcs/main.vue